import moment from "moment";
import ClearIcon from '@mui/icons-material/Clear';
import AnswerCell from "./AnswerCell";
import { getStateOfPoll } from "../../helpers/utils";
import SweetAlert from "../SweetAlert/SweetAlert"
import Swal from 'sweetalert2';
import { archivePoll, deletePoll, endPoll, startPoll } from "../../store/slices/pollSlice";
import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";

const PollCell = ({ poll ,votesCount,contest}) => {

    return (
        <div className="pb-2">
            <div >
                <div className="header-section">
                    <p className="f-12 mb-0">Question</p>
                    <p className="f-12 text-wrap"><strong>{poll?.attributes?.title}</strong></p>
                </div>
            </div>
            <div >
                <div>
                    {poll?.relations?.answers?.data?.map((answer, index) => (
                        <AnswerCell key={index} answerIndex={index} answer={answer} totalVotesCount={votesCount} contest={contest}/>
                    ))}
                </div>
            </div>
        </div>
    )
};

export default PollCell;